function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0Check {\r\n        fill: currentColor;\r\n        stroke-width: 0px;\r\n      }\r\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0Check",
  d: "M17.6,3C15.6,1,12.9,0,10.3,0S5,1,3,3C-1,7-1,13.5,3,17.6c2,2,4.6,3,7.3,3s5.3-1,7.3-3c4-4,4-10.5,0-14.5ZM16.4,16.4c-1.6,1.6-3.8,2.5-6.1,2.5s-4.5-.9-6.1-2.5C.8,13,.8,7.5,4.1,4.1c1.6-1.6,3.8-2.5,6.1-2.5s4.5.9,6.1,2.5c3.4,3.4,3.4,8.9,0,12.3Z"
});

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  className: "st0Check",
  points: "8.9 10.8 6.8 8.5 4.4 10.8 4.4 10.8 8.8 15.2 16.3 7.8 14.6 6 8.9 10.8"
});

var SvgChek = function SvgChek(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "chekSVG",
    "data-name": "Layer 1",
    viewBox: "0 0 20.6 20.6",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChek, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Chek.4b026836.svg";
export { ForwardRef as ReactComponent };